// @flow
import { useEffect, useCallback } from 'react';
import { Megaphone } from '../../lib/Megaphone';

export default function useWindowEvents(childReference: any) {
    useEffect(
        () => {
            const eventHandler = (message: any) => {
                const { event, data } = message.data;
                if (message.origin.indexOf('trainheroic.com') > -1) {
                    Megaphone.emit(event, data);
                }
            };

            window.addEventListener('message', eventHandler);
            return () => {
                window.removeEventListener('message', eventHandler);
            };
        },
        [childReference]
    );

    const emit = useCallback((event: string, data: any) => {
        if (childReference && childReference.current) {
            childReference.current.contentWindow.postMessage(
                {
                    event,
                    data
                },
                '*'
            );
        } else {
            window.parent.postMessage(
                {
                    event,
                    data
                },
                '*'
            );
        }
        /* eslint-disable-next-line */
    }, []);

    const on = useCallback((event: string, callback: any) => {
        Megaphone.addListener(event, callback);
        /* eslint-disable-next-line */
    }, []);

    return {
        emit,
        on
    };
}



// WEBPACK FOOTER //
// ./src/v5/home/components/hooks/useWindowEvents.js